export const defaultProperties = {
    transitionDuration: 400,
    minSwipeDistance: 50,
    transitionTimingFunction: 'ease',
    counterSeparator: " / ",
    arrows: true
}